import React from 'react';
import styled from 'styled-components';
import Comment from './comment';
import { renderMarksColors, renderMarksEnums } from './renderMarksEnums';

const Mark = styled.mark`
  padding: 0px;
  background-color: ${(props) => props.color};
`;

const renderMark = (props, editor, next) => {
  const { children } = props;
  switch (props.mark.type) {
    case 'bold':
      return <strong>{children}</strong>;
    case 'code':
      return <code>{children}</code>;
    case 'italic':
      return <em>{children}</em>;
    case 'strikethrough':
      return <del>{children}</del>;
    case 'underline':
      return <u>{children}</u>;
    case 'subscript':
      return <sub>{children}</sub>;
    case 'superscript':
      return <sup>{children}</sup>;
    case 'comment':
      return <Comment {...props} />;
    case 'fakeSelection':
      return (
        !editor.value.selection.isFocused && (
          <Mark color="#f0e5aa">{children}</Mark>
        )
      );
    case renderMarksEnums.HIGHLIGHT_GRAMMAR_ERROR:
      return (
        !editor.value.selection.isFocused && (
          <Mark
            color={renderMarksColors[renderMarksEnums.HIGHLIGHT_GRAMMAR_ERROR]}
          >
            {children}
          </Mark>
        )
      );
    case renderMarksEnums.HIGHLIGHT_ACTION_VERB_ERROR:
      return (
        !editor.value.selection.isFocused && (
          <Mark
            color={
              renderMarksColors[renderMarksEnums.HIGHLIGHT_ACTION_VERB_ERROR]
            }
          >
            {children}
          </Mark>
        )
      );
    case renderMarksEnums.HIGHLIGHT_PRONOUN_ERROR:
      return (
        !editor.value.selection.isFocused && (
          <Mark
            color={renderMarksColors[renderMarksEnums.HIGHLIGHT_PRONOUN_ERROR]}
          >
            {children}
          </Mark>
        )
      );
    case renderMarksEnums.HIGHLIGHT_SELECTED_ERROR:
      return (
        !editor.value.selection.isFocused && (
          <Mark
            color={renderMarksColors[renderMarksEnums.HIGHLIGHT_SELECTED_ERROR]}
          >
            {children}
          </Mark>
        )
      );
    case renderMarksEnums.HIGHLIGHT_DEFAULT_ERROR:
      return (
        !editor.value.selection.isFocused && (
          <Mark
            color={renderMarksColors[renderMarksEnums.HIGHLIGHT_DEFAULT_ERROR]}
          >
            {children}
          </Mark>
        )
      );
    case renderMarksEnums.HIGHLIGHT_ADDRESS_ERROR:
      return (
        !editor.value.selection.isFocused && (
          <Mark
            color={renderMarksColors[renderMarksEnums.HIGHLIGHT_ADDRESS_ERROR]}
          >
            {children}
          </Mark>
        )
      );
    default:
      return next();
  }
};

export default renderMark;
